import React, { memo } from "react";
import {
  Box,
  Typography,
  Avatar,
  Paper,
  Rating,
  Stack,
} from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import { Review,  RecentReviewsProps } from "../TalentDashboardInterface/TalentDashboardInterface";


const RecentReviews: React.FC<RecentReviewsProps> = ({
  reviews,
  maxItems = 5,
}) => {
  const visibleReviews = reviews.slice(0, maxItems);

  return (
    <Box>
      <Typography variant="h6" fontWeight={600} mb={2}>
        Recent Reviews
      </Typography>

      <Stack spacing={2}>
        {visibleReviews.map((review) => (
          <Paper
            key={review.id}
            elevation={1}
            sx={{
              p: 2,
              borderRadius: 3,
              bgcolor: "#FAFAFF",
              border: "1px solid #E5E7EB",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
              },
            }}
          >
            <Stack direction="row" spacing={2}>
              <Avatar src={review.reviewerAvatar} alt={review.reviewerName} />
              <Box flexGrow={1}>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  justifyContent="space-between"
                  alignItems={{ sm: "center" }}
                  spacing={0.5}
                >
                  <Typography fontWeight={600}>{review.reviewerName}</Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {formatDistanceToNow(new Date(review.createdAt), {
                      addSuffix: true,
                    })}
                  </Typography>
                </Stack>

                {review.cardTitle && (
                  <Typography fontSize={13} color="text.secondary" mb={0.5}>
                    Card: {review.cardTitle}
                  </Typography>
                )}

                <Rating
                  value={review.rating}
                  precision={0.5}
                  size="small"
                  readOnly
                />

                <Typography mt={0.5} fontSize={14} color="text.primary">
                  {review.comment}
                </Typography>
              </Box>
            </Stack>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
};

export default memo(RecentReviews);
